import React, { createContext, useContext, useEffect, useState, useCallback } from 'react'
import { useTheme }  from '~/contexts/ThemeContext'

const PostContext = createContext();

export function PostProvider({ children, post, pgprops }) {
  const { setQuick, setTransBg } = useTheme()

  let quickColorOOS = []
  if (post?.quick_color_oos?.length > 0) {
    quickColorOOS = post.quick_color_oos
  }

  const [quickProds, setQuickProds] = useState([])

  const onQuick = useCallback((mid) => {
    if (!quickProds || quickProds.length < 1) return
    const quick_obj = quickProds.find(x => x.prod_mid === mid)
    window._conv_q = window._conv_q || []
    window._conv_q.push(["triggerConversion", "100458750"])
    setQuick(quick_obj)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quickProds])


  const [props, setProps] = useState({
    ...pgprops,
    quickProds: [], 
    quickColorOOS: quickColorOOS, 
    onQuick: onQuick
  })

  const check_quicks = () => {
    let qProds = []
    if (post.quick_obj?.length > 0 && post.quick_pls?.length > 0) {
      post.quick_obj.forEach( p_obj => {
        const pl_info = post.quick_pls.find(x => !!x && x.mid === p_obj.pl_mid)


        if (!pl_info) return
        const prod_info = pl_info.products.find(x => !!x && x.mid === p_obj.id)
        if (!prod_info) return

        const shop_id = prod_info.shop_id

        const products = pl_info.products.map(prod => {
          let nprod = structuredClone(prod)
          const color = pl_info.colors?.standard?.find(x => x.shop_id === nprod.shop_id) || pl_info.colors?.venice_wash?.find(x => x.shop_id === nprod.shop_id)

          const plfilt_keys = Object.keys(pl_info.filters)
          plfilt_keys.forEach(filter => {

            if (nprod.filters.hasOwnProperty(filter)) {
              nprod.filters[filter] = nprod.filters[filter].concat(pl_info.filters[filter])
            } else {
              nprod.filters[filter] = pl_info.filters[filter]
            }
          })

          nprod = {
            ...nprod,
            category: pl_info.category,
            callouts: nprod.callouts,
            color: color,
            pl_colors: pl_info.colors,
            short_description: pl_info.short_description,
            description: pl_info.description,
            gender: pl_info.gender,
            pl_pima: p_obj.pl_mid,
            pl_handle: pl_info.handle,
            pl_name: pl_info.name,
            product_line: {mid: p_obj.pl_mid}
          }
          return nprod
        })

        let obj = {
          selected: shop_id,
          handle: p_obj.handle,
          prod_mid: p_obj.id,
          products: products
        }

        let oos_replace = quickColorOOS.find(x => !!x && x.replace === p_obj.handle)
        if (oos_replace) {
          obj['oos_replace'] = true
        }

        qProds.push(obj)
      })
    }
    setQuickProds(qProds)
  }


  useEffect(() => {
    setProps(prev => ({
      ...prev,
      quickProds: quickProds,
      onQuick: onQuick 
    }))
  }, [quickProds, onQuick])

  useEffect(() => {
    if (!post) return
    const postbg = post.bg_color ? post.bg_color : '#fff'
    setTransBg(postbg)
    check_quicks()

    if (post.bg_color !== '#fff') {
      document.querySelector('body').style.backgroundColor = post.bg_color
      setTransBg(postbg)
    }

    return () => {
      document.querySelector('body').style.backgroundColor = null
      setTransBg('#fff')
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])



  return (
    <PostContext.Provider value={{ post, props }}>
      {children}
    </PostContext.Provider>
  );
}

export function usePost() {
  return useContext(PostContext)
}